// import { Box, Container, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import {PatternsScheduleWork} from "../../components/PatternSchedules/PatternsListPage.tsx";
// import { useTranslation } from "react-i18next"
// import useAuth from "../../hooks/useAuth"

// import  PatternForm  from "../../components/PatternSchedules/PatternForm"

export const Route = createFileRoute("/_layout/pattern-schedules")({
    component: PatternsScheduleWork,
})